import { render, staticRenderFns } from "./FeaturesByGroup.vue?vue&type=template&id=244b6d08&"
import script from "./FeaturesByGroup.vue?vue&type=script&lang=js&"
export * from "./FeaturesByGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports